import { render } from "./title-button.vue?vue&type=template&id=945d1f18&scoped=true&ts=true"
import script from "./title-button.vue?vue&type=script&lang=ts"
export * from "./title-button.vue?vue&type=script&lang=ts"

import "./title-button.vue?vue&type=style&index=0&id=945d1f18&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-945d1f18"]])

export default __exports__